import { Component } from "preact";
import scrollTo from "scroll-to-element";

export default class AnchorLink extends Component {

	onClick = (e) => {
		e.preventDefault();

		const { target } = this.props;
		scrollTo(document.getElementById(target), {
			offset: -50,
			ease: 'in-out-expo',
			duration: 1000
		});
	};

	componentDidMount(){
		const { target } = this.props;

		const el = document.getElementById(target);
		if(el) el.classList.add("anchorElement");
	}

	render(props, state, ctx) {
		const { children, target } = props;

		return (
			<a href={`#${target}`} onClick={this.onClick}>
				{children}
			</a>
		);
	}

}



// WEBPACK FOOTER //
// ./components/AnchorLink/AnchorLink.js